import { AUTOMATIONS_DEFAULT_NAME } from "../../../i18n/keysTranslations";

export const buildDefaultAutomationName = (t) => {
  const formattedDate = new Date().toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  return t(AUTOMATIONS_DEFAULT_NAME, { date: formattedDate });
};
